import React, {useState} from "react";
import AdminPanelLayaut from "./layaut/AdminPanelLayaut";
import {Button, Flex, Form, Input, message} from "antd";

const BrakUprawnien = () => {

    return (
        <AdminPanelLayaut label={''}>
            <Flex justify={'center'} align={'center'} vertical >
                <h5>Brak uprawnień !</h5>
                <p>Nie posiadasz odpowiednich uprawnień do tej strony.</p>
            </Flex>
        </AdminPanelLayaut>
    )
}

export default BrakUprawnien;
